import React, { useState } from "react";
import MainCard from "../../../Components/Cards/MainCard";
import { Controller, useForm } from "react-hook-form";
import SelectFieldComponent from "../../../Components/CustomComponents/SelectFieldComponent";
import _ from "lodash";
import { InputGroup } from "react-bootstrap";
import { Input } from "../../../Components/CustomComponents";
import Table from "../../../Components/Table/Table";
import styles from "../styles/user_management.module.scss";
import ToolTip from "../../../Components/CustomComponents/ToolTip";

const TransactionOrderLog = ({ data }) => {
  const { control, watch } = useForm({
    defaultValues: {
      status: "",
      type: "",
    },
  });

  const status = watch("status");
  const type = watch("type");

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo

  const [indicationMessage, setIndicationMessage] = useState("loading...");

  const filterData = [
    {
      value: "all",
      label: "All",
    },
    {
      value: 0,
      label: "Active",
    },
    {
      value: 1,
      label: "InActive",
    },
  ];

  function indication() {
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "id",
      text: "ORDER ID",
      headerStyle: { width: "120px" },
      formatter: (cellContent, row) => (
        <span className="text-wrap-custom">{cellContent}</span>
      ),
    },
    {
      dataField: "type",
      text: "TYPE",
      headerStyle: { width: "150px" },
      formatter: (cellContent, row) => (
        <span className="text-wrap-custom">{cellContent}</span>
      ),
    },
    {
      dataField: "from",
      text: "FROM",
      headerStyle: { width: "150px" },
      formatter: (cellContent, row) => (
        <span className="text-wrap-custom">{cellContent}</span>
      ),
    },
    {
      dataField: "to",
      text: "TO",
      headerStyle: { width: "150px" },
      formatter: (cellContent, row) => (
        <span className="text-wrap-custom">{cellContent}</span>
      ),
    },
    {
      dataField: "amount",
      text: "AMOUNT",
      headerStyle: { width: "120px" },
      formatter: (cellContent, row) => (
        <span className="text-wrap-custom">{cellContent}</span>
      ),
    },
    {
      dataField: "account",
      text: "ACCOUNT",
      headerStyle: { width: "150px" },
      formatter: (cellContent, row) => (
        <span className="text-wrap-custom">{cellContent}</span>
      ),
    },
    {
      dataField: "status",
      text: "STATUS",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "120px" },
      formatter: (cellContent) => {
        let badgeClass;
        switch (cellContent) {
          case "Completed":
            badgeClass = "bg-success"; // Green badge for Completed
            break;
          case "Pending":
            badgeClass = "bg-warning text-dark";
            break;
          case "In Escrow":
            badgeClass = "bg-info text-dark";
            break;
          default:
            badgeClass = "bg-secondary";
        }

        return (
          <span className={`badge rounded-pill ${badgeClass}`}>
            {cellContent}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "DATE",
      headerStyle: { width: "100px" },
      formatter: (cellContent, row) => (
        <span className="text-wrap-custom">{cellContent}</span>
      ),
    },

    // {
    //   dataField: "actions",
    //   text: "Actions",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: { width: "200px" },
    //   formatter: (cellContent, row) => (
    //     <div className="d-flex justify-content-center gap-2">
    //       <ToolTip placement={"top"} content={"Send"}>
    //         <button
    //           className="btn btn-sm btn-success rounded-circle pb-2"
    //           onClick={() => {
    //             // setEditedData(row);
    //             // handleSendModalOpen();
    //           }}
    //         >
    //           {/* <FiSend /> */}
    //         </button>
    //       </ToolTip>
    //       <ToolTip placement={"top"} content={"Download"}>
    //         <button
    //           className="btn btn-sm btn-primary rounded-circle pb-2"
    //           onClick={() => alert(`Downloading agreement of ${row.name}`)}
    //         >
    //           {/* <FiDownload /> */}
    //         </button>
    //       </ToolTip>
    //     </div>
    //   ),
    // },
  ];

  return (
    <MainCard>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Transaction Order Log</h5>
        <div className="d-flex  gap-3 flex-wrap">
          <Controller
            control={control}
            name="status"
            render={({ field: { onChange, value } }) => (
              <span style={{ minWidth: "200px" }}>
                <SelectFieldComponent
                  firstOption={_.isEmpty(value) ? "Select Status" : value}
                  optionsList={filterData}
                  onSelectChange={onChange}
                />
              </span>
            )}
          />
          <Controller
            control={control}
            name="type"
            render={({ field: { onChange, value } }) => (
              <span style={{ minWidth: "200px" }}>
                <SelectFieldComponent
                  firstOption={_.isEmpty(value) ? "Select Type" : value}
                  optionsList={filterData}
                  onSelectChange={onChange}
                />
              </span>
            )}
          />
          <Controller
            control={control}
            name="date"
            render={({ field }) => (
              <span style={{ minWidth: "200px" }}>
                <InputGroup>
                  <Input {...field} placeholder="Enter Date" type="date" />
                </InputGroup>
              </span>
            )}
          />
        </div>
      </div>
      <div
        // className={`${styles.mainTable} ${dataFetched && isFetching ? "blur-table" : ""}`}
        className={`${styles.mainTable} small`}
      >
        {/* {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : ( */}
        <Table
          // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
          data={data || []}
          columns={columns}
          indication={indication}
          totalRecords={totalRecords} // todo
          totalPages={totalPages} // todo
          pageSize={pageSize} // todo
          currentPage={currentPage} // todo
          setCurrentPage={setCurrentPage} // todo
          setPageSize={setPageSize} // todo
          // refetch={refetch} // todo
          refetch={() => {}}
        />
        {/* )} */}
      </div>
    </MainCard>
  );
};

export default TransactionOrderLog;
